import Link from 'next/link'
import React from 'react'
import { Program } from '~shared/api/categories/types'
import { Button } from '~shared/components/button-v2'
import { Hit } from '~shared/icons/hit'
import { LeadFormDialog } from '~widgets/lead-form/components/lead-form-dialog'

interface ProgramWithColor extends Program {
  faculty: Program['faculty'] & {
    color: string | null | undefined
  }
}

type Props = {
  program: ProgramWithColor
}

export const ProgramCard: React.FC<Props> = ({ program }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const monthPriceCalc = (price: number, discount?: number) => {
    const regularPrice =
      Math.round(
        Math.ceil(
          (price / (100 - ((discount && Number(discount)) || 30))) * 100
        ) / 10
      ) * 10
    const regularPriceOneMonth =
      Math.round(Math.ceil(regularPrice / 12) / (100 / 10)) * (100 / 10)

    const discountedPriceOneMonth =
      Math.round(Math.ceil(price / 12) / (100 / 10)) * (100 / 10)

    return discount ? discountedPriceOneMonth : regularPriceOneMonth
  }
  return (
    <div className='rounded-[24px] p-[16px] xl:p-[24px] bg-[#F2F2F2] overflow-hidden flex flex-col'>
      <div className='flex justify-between'>
        <div className='flex text-[14px] md:text-[16px] flex-wrap gap-y-[8px]'>
          <span
            className='px-[10px] py-[4px] md:py-[8px] flex items-center max-w-[190px] rounded-[24px]'
            style={
              program.faculty?.color
                ? {
                    backgroundColor: `${program.faculty?.color}30`,
                    color: program.faculty?.color
                  }
                : {}
            }>
            {program?.faculty?.name}
          </span>
          <span className='bg-white px-[10px]  flex items-center rounded-[24px] h-[27px] md:h-[37px]'>
            {program.category?.name}
          </span>
        </div>
        {program.popular && (
          <span className='flex items-center rounded-[24px] gap-[4px] bg-[#FFF741] px-[10px] h-[27px] md:h-[37px]'>
            <Hit size={13} className='mt-[2px] inline-block' />
            хит
          </span>
        )}
      </div>
      <p className='font-medium mb-[8px] mt-[16px] md:text-[20px] xl:text-[24px] md:my-[16px] xl:mt-[24px] xl:mb-[16px] line-clamp-2 overflow-hidden text-programlipsis'>
        {program.name}
      </p>
      <p className='text-[14px] mb-[16px] text-[#6A6A6A]'>
        {Number(program.cost?.studyDurationYears) > 0 && (
          <span>{program.cost?.studyDurationYears} год </span>
        )}
        {Number(program.cost?.studyDurationYears) > 0 &&
          Number(program.cost?.studyDurationMonths) > 0 && <span>/ </span>}
        {Number(program.cost?.studyDurationMonths) > 0 && (
          <span>{program.cost?.studyDurationMonths} мес </span>
        )}
        {Number(program.cost?.studyHours) > 0 && (
          <span>/ {program.cost?.studyHours} часов </span>
        )}
      </p>
      <p className='font-medium text-[16px] md:text-[20px] xl:text-[24px] mb-[16px] xl:mb-[24px] mt-[14px] md:mt-auto'>
        от{' '}
        {monthPriceCalc(program.cost?.price ?? 0, program.cost?.discount ?? 0)}{' '}
        ₽/мес.
        <span className='ml-[16px] text-[14px] line-through text-[#00000050]'>
          {monthPriceCalc(program.cost?.price ?? 0)} ₽/мес
        </span>
      </p>
      <div className='grid grid-cols-2 gap-[8px] '>
        <Button
          onClick={() => setIsOpen(true)}
          className='rounded-[16px] duration-200 ease-in-out justify-center bg-accent text-white flex items-center h-[50px] hover:bg-black'>
          Поступить
        </Button>
        <LeadFormDialog open={isOpen} onOpenChange={setIsOpen} />
        <Link
          prefetch={false}
          href={`/${program.slug}--${
            program.category?.slugSingular ?? program.category?.slug
          }`}
          className='rounded-[16px] justify-center bg-[#3A52EE1A] duration-200 ease-in-out text-accent flex items-center h-[50px] hover:bg-white hover:text-black'>
          Подробнее
        </Link>
      </div>
    </div>
  )
}
